import { FC } from "react";

import { ReactComponent as Logo } from "./Logo.svg";

import styles from "./styles.module.scss";

const AllRightReserved: FC = () => {
    return (
        <div className={styles.allRightReserved}>
            <span>Powered by </span>
            <Logo />
            <p>© BoomForm 2025. All rights reserved.</p>
        </div>
    );
};

export default AllRightReserved;
